import { SET_USER, UPDATE_USER } from '../constants/actionTypes';

const user = (user = {}, action) => {
  switch (action.type) {
    case SET_USER:
      return action.payload;
    case UPDATE_USER:
      return { ...user, 
        ...action.payload };
    default:
      return user;
  }
};

export default user;